import React, { useEffect, useContext } from 'react'
import styled from 'styled-components'
import { NavLink, Redirect, Route, Switch, useRouteMatch } from 'react-router-dom'

import { EmbedIntegrationsDescription } from 'components/EmbedIntegrationsDescription'
import { Menu, Message } from 'semantic-ui-react'
import IntercomInAppPublish from 'components/IntercomInAppPublish'
import IntercomTextPublish from 'components/IntercomTextPublish'
import { surveySettingContext } from 'pages/SurveySettings/context'
import ErrorBoundary from 'components/ErrorBoundary'

const MenuContainer = styled.div`
  background: white;
  border-bottom: 1px solid #e5e5e5;

  .ui.secondary.pointing.menu {
    border: 0;
  }
  .ui.secondary.pointing.menu .item {
    padding: 18px 20px;
  }

  .ui.secondary.pointing.menu a.active .item {
    border-bottom: 3px solid #53b573;
  }
`

/**
 *
 * @param {object} props
 * @param {object} props.primaryQuestion
 * @param {object} props.language
 * @param {string} props.surveyToken
 * @param {number} props.surveyId
 * @param {object} props.intercomSurveyConfiguration
 */
export default function IntercomSurveyPublish({
  primaryQuestion,
  surveyToken,
  surveyId,
  language,
  intercomSurveyConfiguration,
  isReverseOrder,
}) {
  const match = useRouteMatch()
  const { setContext } = useContext(surveySettingContext)

  useEffect(() => {
    setContext({ isSaveButtonHidden: true })
    return () => {
      setContext({ isSaveButtonHidden: false })
    }
  }, [setContext])

  return (
    <div>
      <EmbedIntegrationsDescription label="Intercom" titleClassName="mb3" />
      <MenuContainer className="mb4">
        <div className="flex">
          <Menu pointing secondary>
            <NavLink to={`${match.url}/intercom-app/`}>
              <Menu.Item>
                <i className="fab fa-intercom mr2" />
                Send as an app
              </Menu.Item>
            </NavLink>
            <NavLink to={`${match.url}/intercom-text/`}>
              <Menu.Item>
                <i className="far fa-comment-dots mr2" />
                Send as text
              </Menu.Item>
            </NavLink>
          </Menu>
        </div>
      </MenuContainer>
      {intercomSurveyConfiguration && (
        <Switch>
          <Route path={`${match.path}intercom-app/`}>
            <ErrorBoundary
              errorFallback={() => {
                return (
                  <Message negative>
                    <strong>Whoops!</strong> Something went wrong. Please contact Simplesat support
                    to help you out.
                  </Message>
                )
              }}
            >
              <IntercomInAppPublish
                surveyToken={surveyToken}
                surveyId={surveyId}
                intercomSurveyConfiguration={intercomSurveyConfiguration}
              />
            </ErrorBoundary>
          </Route>
          <Route path={`${match.path}intercom-text/`}>
            <IntercomTextPublish
              primaryQuestion={primaryQuestion}
              surveyToken={surveyToken}
              language={language}
              intercomSurveyConfiguration={intercomSurveyConfiguration}
              isReverseOrder={isReverseOrder}
            />
          </Route>
          <Route path={match.path}>
            <Redirect to={`${match.url}/intercom-app/`} />
          </Route>
        </Switch>
      )}
    </div>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/IntercomSurveyPublish/index.js